// extracted by mini-css-extract-plugin
export var component = "Breadcrumbs-module--component--cs3Jb";
export var description = "Breadcrumbs-module--description--ucWxp";
export var item = "Breadcrumbs-module--item--YsZ9f";
export var link = "Breadcrumbs-module--link--vsnd4";
export var list = "Breadcrumbs-module--list--0BJSl";
export var separator = "Breadcrumbs-module--separator--yXm+S";